import type { CrmMessages } from "./englishCrmMessages";

// Plural forms (polyglot, locale "uk"): one |||| few (2-4) |||| many (5+)
export const ukrainianCrmMessages = {
  resources: {
    companies: {
      name: "Компанія |||| Компанії |||| Компаній",
      forcedCaseName: "Компанія",
      fields: {
        name: "Назва компанії",
        website: "Сайт",
        linkedin_url: "LinkedIn",
        phone_number: "Телефон",
        created_at: "Створено",
        nb_contacts: "Кількість контактів",
        revenue: "Дохід",
        sector: "Галузь",
        size: "Розмір",
        tax_identifier: "Код ЄДРПОУ / ІПН",
        address: "Адреса",
        city: "Місто",
        zipcode: "Поштовий індекс",
        state_abbr: "Область",
        country: "Країна",
        description: "Опис",
        context_links: "Корисні посилання",
        sales_id: "Відповідальний",
      },
      empty: {
        description: "Схоже, список компаній порожній.",
        title: "Компаній не знайдено",
      },
      import: {
        title: "Імпорт компаній",
      },
      field_categories: {
        contact: "Контакти",
        additional_info: "Додаткова інформація",
        address: "Адреса",
        context: "Контекст",
      },
      action: {
        create: "Створити компанію",
        edit: "Редагувати компанію",
        new: "Нова компанія",
        show: "Переглянути компанію",
      },
      added_on: "Додано %{date}",
      followed_by: "Веде %{name}",
      followed_by_you: "Ведете ви",
      no_contacts: "Немає контактів",
      nb_contacts:
        "%{smart_count} контакт |||| %{smart_count} контакти |||| %{smart_count} контактів",
      nb_deals:
        "%{smart_count} угода |||| %{smart_count} угоди |||| %{smart_count} угод",
      sizes: {
        one_employee: "1 працівник",
        two_to_nine_employees: "2–9 працівників",
        ten_to_forty_nine_employees: "10–49 працівників",
        fifty_to_two_hundred_forty_nine_employees: "50–249 працівників",
        two_hundred_fifty_or_more_employees: "250 і більше працівників",
      },
      autocomplete: {
        create_error: "Не вдалося створити компанію",
        create_item: "Створити %{item}",
        create_label: "Почніть вводити, щоб створити компанію",
      },
    },
    contacts: {
      name: "Контакт |||| Контакти |||| Контактів",
      forcedCaseName: "Контакт",
      field_categories: {
        background_info: "Довідка",
        identity: "Особа",
        misc: "Інше",
        personal_info: "Контактні дані",
        position: "Посада",
      },
      fields: {
        first_name: "Ім'я",
        last_name: "Прізвище",
        last_seen: "Остання активність",
        title: "Посада",
        company_id: "Компанія",
        email_jsonb: "Електронні адреси",
        email: "Email",
        phone_jsonb: "Телефони",
        phone_number: "Телефон",
        linkedin_url: "LinkedIn",
        background: "Довідка (звідки прийшов, що цікавить тощо)",
        has_newsletter: "Підписаний на розсилку",
        sales_id: "Відповідальний",
        created_at: "Створено",
        source: "Джерело",
        source_form: "Форма",
        campaign: "Кампанія",
        utm: "UTM",
        first_action_at: "Перша дія",
      },
      sources: {
        facebook: "Facebook",
        instagram: "Instagram",
        site: "Сайт",
        phone: "Дзвінок",
        referral: "Рекомендація",
        import: "Імпорт",
        manual: "Вручну",
        other: "Інше",
      },
      action: {
        add: "Додати контакт",
        add_first: "Додайте перший контакт",
        create: "Створити контакт",
        edit: "Редагувати контакт",
        export_vcard: "Експорт у vCard",
        new: "Новий контакт",
        show: "Переглянути контакт",
      },
      autocomplete: {
        create_item: "Створити %{item}",
        create_label: "Почніть вводити, щоб створити контакт",
      },
      background: {
        last_activity_on: "Остання активність %{date}",
        added_on: "Додано %{date}",
        followed_by: "Веде %{name}",
        followed_by_you: "Ведете ви",
        status_none: "Немає",
      },
      position_at: "%{title},",
      position_at_company: "%{title}, %{company}",
      empty: {
        description: "Схоже, список контактів порожній.",
        title: "Контактів не знайдено",
      },
      import: {
        title: "Імпорт контактів",
      },
      inputs: {
        genders: {
          male: "Чоловік",
          female: "Жінка",
          nonbinary: "Інше",
        },
        personal_info_types: {
          work: "Робочий",
          home: "Особистий",
          other: "Інший",
        },
      },
      list: {
        error_loading: "Не вдалося завантажити контакти",
      },
      show: {
        error_loading: "Не вдалося завантажити контакт",
      },
      bulk_tag: {
        action: "Тег",
        back: "Назад до тегів",
        create_description:
          "Створіть новий тег і додайте його вибраним контактам.",
        description:
          "Виберіть наявний тег або створіть новий для вибраних контактів.",
        empty: "Тегів ще немає. Створіть тег для вибраних контактів.",
        error: "Не вдалося додати тег контактам",
        removed:
          "Тег знято з %{smart_count} контакту |||| Тег знято з %{smart_count} контактів |||| Тег знято з %{smart_count} контактів",
        success:
          "Тег додано %{smart_count} контакту |||| Тег додано %{smart_count} контактам |||| Тег додано %{smart_count} контактам",
        title: "Додати тег контактам",
      },
      merge: {
        action: "Об'єднати з іншим контактом",
        confirm: "Об'єднати контакти",
        current_contact: "Поточний контакт (буде видалено)",
        description: "Об'єднати цей контакт з іншим.",
        error: "Не вдалося об'єднати контакти",
        merging: "Об'єднуємо...",
        no_additional_data: "Немає додаткових даних для об'єднання",
        select_target: "Виберіть контакт для об'єднання",
        success: "Контакти об'єднано",
        target_contact: "Цільовий контакт (залишиться)",
        title: "Об'єднання контактів",
        warning_description:
          "Усі дані перейдуть до другого контакту. Скасувати це неможливо.",
        warning_title: "Увага: незворотна дія",
        what_will_be_merged: "Що буде об'єднано:",
      },
      filters: {
        before_last_month: "Раніше минулого місяця",
        before_this_month: "Раніше цього місяця",
        before_this_week: "Раніше цього тижня",
        managed_by_me: "Мої",
        search: "Пошук за ім'ям, компанією...",
        this_week: "Цього тижня",
        today: "Сьогодні",
        tags: "Теги",
        tasks: "Задачі",
      },
      hot: {
        empty_change_status:
          "Змініть статус контакту: додайте нотатку і натисніть «показати параметри».",
        empty_hint: "Тут з'являться контакти зі статусом «гарячий».",
        title: "Гарячі контакти",
      },
    },
    deals: {
      name: "Угода |||| Угоди |||| Угод",
      fields: {
        name: "Назва",
        description: "Опис",
        company_id: "Компанія",
        contact_ids: "Покупці",
        categories: "Категорії",
        amount: "Сума",
        expected_closing_date: "Очікувана дата закриття",
        stage: "Етап",
        apartment_id: "Квартира",
        lost_reason: "Причина втрати",
        lost_comment: "Коментар",
        lost_at: "Втрачено",
      },
      action: {
        back_to_deal: "Назад до угоди",
        create: "Створити угоду",
        new: "Нова угода",
      },
      field_categories: {
        misc: "Інше",
      },
      filters: {
        only_mine: "Лише мої угоди",
      },
      archived: {
        action: "Архівувати",
        error: "Помилка: угоду не архівовано",
        list_title: "Архівні угоди",
        success: "Угоду архівовано",
        title: "Архівна угода",
        view: "Переглянути архівні угоди",
      },
      inputs: {
        linked_to: "Пов'язано з",
      },
      unarchived: {
        action: "Повернути на дошку",
        error: "Помилка: угоду не повернуто з архіву",
        success: "Угоду повернуто з архіву",
      },
      updated: "Угоду оновлено",
      empty: {
        before_create: "перед створенням угоди.",
        description: "Схоже, список угод порожній.",
        title: "Угод не знайдено",
      },
      import: {
        title: "Імпорт угод",
      },
      invalid_date: "Некоректна дата",
    },
    notes: {
      name: "Нотатка |||| Нотатки |||| Нотаток",
      forcedCaseName: "Нотатка",
      fields: {
        status: "Статус",
        date: "Дата",
        attachments: "Вкладення",
        contact_id: "Контакт",
        deal_id: "Угода",
      },
      action: {
        add: "Додати нотатку",
        add_first: "Додайте першу нотатку",
        delete: "Видалити нотатку",
        edit: "Редагувати нотатку",
        update: "Оновити нотатку",
        add_this: "Додати цю нотатку",
      },
      sheet: {
        create: "Нова нотатка",
        create_for: "Нова нотатка для %{name}",
        edit: "Редагувати нотатку",
        edit_for: "Редагувати нотатку для %{name}",
      },
      deleted: "Нотатку видалено",
      empty: "Нотаток ще немає",
      author_added: "%{name} додав(ла) нотатку",
      you_added: "Ви додали нотатку",
      me: "Я",
      list: {
        error_loading: "Не вдалося завантажити нотатки",
      },
      note_for_contact: "Нотатка для %{name}",
      stepper: {
        hint: "Відкрийте контакт і додайте нотатку",
      },
      added: "Нотатку додано",
      inputs: {
        add_note: "Додати нотатку",
        options_hint: "(прикріпити файли або змінити деталі)",
        show_options: "Показати параметри",
      },
      actions: {
        attach_document: "Прикріпити документ",
      },
      validation: {
        note_or_attachment_required: "Потрібен текст нотатки або вкладення",
      },
    },
    sales: {
      name: "Користувач |||| Користувачі |||| Користувачів",
      fields: {
        first_name: "Ім'я",
        last_name: "Прізвище",
        email: "Email",
        secondary_email: "Додатковий email",
        secondary_emails: "Додаткові email",
        administrator: "Адміністратор",
        role_id: "Роль",
        disabled: "Вимкнено",
      },
      create: {
        error: "Не вдалося створити користувача.",
        success:
          "Користувача створено. Незабаром він отримає лист для встановлення пароля.",
        title: "Новий користувач",
      },
      edit: {
        error: "Сталася помилка. Спробуйте ще раз.",
        record_not_found: "Запис не знайдено",
        success: "Користувача оновлено",
        title: "Редагування: %{name}",
      },
      action: {
        new: "Новий користувач",
      },
    },
    tasks: {
      name: "Задача |||| Задачі |||| Задач",
      forcedCaseName: "Задача",
      fields: {
        text: "Опис",
        due_date: "Термін",
        type: "Тип",
        contact_id: "Контакт",
        due_short: "до",
      },
      action: {
        add: "Додати задачу",
        create: "Створити задачу",
        edit: "Редагувати задачу",
      },
      actions: {
        postpone_next_week: "Перенести на наступний тиждень",
        postpone_tomorrow: "Перенести на завтра",
        title: "дії із задачею",
      },
      added: "Задачу додано",
      deleted: "Задачу видалено",
      dialog: {
        create: "Нова задача",
        create_for: "Нова задача для %{name}",
      },
      sheet: {
        edit: "Редагувати задачу",
        edit_for: "Редагувати задачу для %{name}",
      },
      empty: "Задач ще немає",
      empty_list_hint: "Тут з'являться задачі, додані до контактів.",
      filters: {
        later: "Пізніше",
        overdue: "Прострочені",
        this_week: "Цього тижня",
        today: "Сьогодні",
        tomorrow: "Завтра",
        with_pending: "З відкритими задачами",
      },
      regarding_contact: "(щодо: %{name})",
      updated: "Задачу оновлено",
    },
    apartments: {
      name: "Квартира |||| Квартири |||| Квартир",
      fields: {
        section: "Секція",
        number: "№ на плані",
        floor: "Поверх",
        rooms: "Кімнат",
        total_area: "Загальна площа",
        living_area: "Житлова площа",
        price_per_m2: "Ціна за м²",
        status: "Статус",
        booked_until: "Бронь до",
      },
      statuses: {
        free: "Вільна",
        booked: "Бронь",
        sold: "Продана",
        off: "Не в продажу",
      },
    },
    calls: {
      name: "Дзвінок |||| Дзвінки |||| Дзвінків",
      fields: {
        started_at: "Дата",
        duration_seconds: "Тривалість",
        result: "Результат",
        comment: "Коментар",
        recording_url: "Запис",
        contact_id: "Лід",
        sales_id: "Менеджер",
      },
      results: {
        no_answer: "Не відповів",
        callback: "Передзвонити",
        viewing_scheduled: "Показ призначено",
        not_interested: "Не цікаво",
        talked: "Поговорили",
      },
    },
    events: {
      name: "Подія |||| Події |||| Подій",
    },
    tags: {
      name: "Тег |||| Теги |||| Тегів",
      action: {
        add: "Додати тег",
        create: "Створити тег",
      },
      dialog: {
        color: "Колір",
        create_title: "Новий тег",
        edit_title: "Редагувати тег",
        name_label: "Назва тегу",
        name_placeholder: "Введіть назву тегу",
      },
      empty: "Тегів ще немає.",
    },
  },
  crm: {
    action: {
      reset_password: "Скинути пароль",
    },
    auth: {
      first_name: "Ім'я",
      last_name: "Прізвище",
      errors: {
        weak_password: "Пароль закороткий: мінімум %{min} символів.",
        invalid_credentials: "Неправильна пошта або пароль.",
        email_not_confirmed:
          "Пошту ще не підтверджено. Перейдіть за посиланням з листа.",
        user_exists: "Користувач з такою поштою вже є.",
        rate_limit: "Забагато спроб. Зачекайте хвилину й спробуйте знову.",
        link_expired:
          "Посилання застаріло або вже використане. Запросіть нове.",
        same_password: "Новий пароль має відрізнятися від старого.",
        invalid_email: "Перевірте адресу пошти.",
        network: "Немає зв'язку з сервером. Перевірте інтернет.",
      },
      login_headline: "Жоден лід не губиться",
      login_subline: "Ліди, дзвінки й шахматка квартир в одному місці.",
      login_hint: "Для менеджерів і керівників відділу продажів",
      confirmed_sign_in: "Я підтвердив, увійти",
      confirm_password: "Підтвердіть пароль",
      confirmation_required:
        "Перейдіть за посиланням з листа, щоб підтвердити акаунт.",
      recovery_email_sent:
        "Якщо ви зареєстровані, незабаром отримаєте лист для відновлення пароля.",
      sign_in_failed: "Не вдалося увійти.",
      sign_in_google_workspace: "Увійти через Google Workspace",
      signup: {
        create_account: "Створити акаунт",
        create_first_user:
          "Створіть першого користувача, щоб завершити налаштування.",
        creating: "Створюємо...",
        initial_user_created: "Першого користувача створено",
      },
      welcome_title: "Вітаємо в Oselya CRM",
    },
    common: {
      account_manager: "Відповідальний",
      activity: "Активність",
      added: "додано",
      details: "Деталі",
      last_activity_with_date: "остання активність %{date}",
      load_more: "Завантажити ще",
      misc: "Інше",
      past: "Минулі",
      read_more: "Читати далі",
      retry: "Повторити",
      show_less: "Згорнути",
      copied: "Скопійовано!",
      copy: "Копіювати",
      loading: "Завантаження...",
      me: "Я",
      task_count:
        "%{smart_count} задача |||| %{smart_count} задачі |||| %{smart_count} задач",
    },
    changelog: {
      title: "Що нового",
    },
    activity: {
      added_company: "%{name} додав(ла) компанію",
      you_added_company: "Ви додали компанію",
      added_contact: "%{name} додав(ла)",
      you_added_contact: "Ви додали",
      added_note: "%{name} додав(ла) нотатку про",
      you_added_note: "Ви додали нотатку про",
      added_note_about_deal: "%{name} додав(ла) нотатку до угоди",
      you_added_note_about_deal: "Ви додали нотатку до угоди",
      added_deal: "%{name} додав(ла) угоду",
      you_added_deal: "Ви додали угоду",
      at_company: "у",
      to: "до",
      load_more: "Показати ще",
    },
    dashboard: {
      deals_chart: "Очікувані надходження за угодами",
      deals_pipeline: "Воронка угод",
      latest_activity: "Остання активність",
      latest_activity_error: "Не вдалося завантажити активність",
      latest_notes: "Мої останні нотатки",
      latest_notes_added_ago: "додано %{timeAgo}",
      stepper: {
        install: "Встановити Oselya CRM",
        progress: "Виконано %{step}/3",
        whats_next: "Що далі?",
      },
      upcoming_tasks: "Найближчі задачі",
    },
    data_import: {
      button: "Імпорт CSV",
      complete:
        "Імпорт завершено. Імпортовано записів: %{importCount}, помилок: %{errorCount}",
      csv_file: "CSV-файл",
      error: "Не вдалося імпортувати файл. Перевірте, що це коректний CSV.",
      in_progress: "Імпорт триває…",
      progress:
        "Імпортовано %{importCount} з %{rowCount} записів, помилок: %{errorCount}.",
      remaining_time: "Залишилось приблизно:",
      resource: "Тип даних",
      sample_download: "Завантажити зразок CSV",
      sample_hint: "Зразок CSV-файлу, який можна взяти за шаблон",
      start: "Почати імпорт",
      stop: "Зупинити імпорт",
      stopped:
        "Імпорт зупинено. Імпортовано записів: %{importCount}, помилок: %{errorCount}",
      title: "Імпорт даних",
    },
    header: {
      import_data: "Імпорт з JSON",
    },
    search: {
      title: "Пошук",
      placeholder: "Пошук контактів, компаній, угод, задач і нотаток...",
      hint: "Введіть щонайменше %{min} символи",
      empty: "Нічого не знайдено",
      error: "Пошук зараз недоступний. Спробуйте ще раз.",
      untitled_result: "(без назви)",
      show_more: "Показати ще",
      groups: {
        contacts: "Контакти",
        companies: "Компанії",
        deals: "Угоди",
        tasks: "Задачі",
        contact_notes: "Нотатки до контактів",
        deal_notes: "Нотатки до угод",
      },
    },
    image_editor: {
      change: "Змінити",
      drop_hint: "Перетягніть файл сюди або натисніть, щоб вибрати.",
      editable_content: "Редагований вміст",
      title: "Завантаження і обрізка зображення",
      update_image: "Оновити зображення",
    },
    import: {
      action: {
        download_error_report: "Завантажити звіт про помилки",
        import: "Імпортувати",
        import_another: "Імпортувати інший файл",
      },
      error: {
        unable: "Не вдалося імпортувати файл.",
      },
      idle: {
        description_1:
          "Можна імпортувати користувачів, компанії, контакти, нотатки й задачі.",
        description_2: "Дані мають бути в JSON-файлі за таким зразком:",
      },
      status: {
        all_success: "Усі записи імпортовано.",
        complete: "Імпорт завершено.",
        failed: "Помилка",
        imported: "Імпортовано",
        in_progress: "Імпорт триває, не закривайте цю сторінку.",
        some_failed: "Деякі записи не імпортовано.",
        table_caption: "Стан імпорту",
      },
      title: "Імпорт з JSON",
    },
    settings: {
      about: "Про систему",
      companies: {
        sectors: "Галузі",
      },
      dark_mode_logo: "Логотип для темної теми",
      deals: {
        categories: "Категорії",
        currency: "Валюта",
        pipeline_help: "Виберіть етапи, які рахуються як угоди у воронці.",
        lost_reasons: "Причини втрати",
        lost_reasons_help:
          "Менеджер обирає причину, коли переносить лід у «Втрачені». За ними рахується аналітика, тож краще не більше 8.",
        pipeline_statuses: "Етапи воронки",
        stages: "Етапи",
      },
      light_mode_logo: "Логотип для світлої теми",
      notes: {
        statuses: "Статуси",
      },
      connectors: {
        title: "Конектори",
        description:
          "Звідки приходять ліди. Ключі доступу зберігаються на сервері, тут лише стан і правила.",
        saved: "Налаштування конектора збережено",
        minutes_ago:
          "%{smart_count} хв тому |||| %{smart_count} хв тому |||| %{smart_count} хв тому",
        hours_ago:
          "%{smart_count} год тому |||| %{smart_count} год тому |||| %{smart_count} год тому",
        days_ago:
          "%{smart_count} день тому |||| %{smart_count} дні тому |||| %{smart_count} днів тому",
        state: {
          on: "Підключено",
          off: "Не підключено",
          error: "Помилка",
          soon: "Скоро",
        },
        site: {
          name: "Форма сайту",
          hint: "Заявки з сайту ЖК одразу у воронку",
        },
        telegram: {
          hint: "Сповіщення про нові ліди й прострочені задачі, керування з бота",
          not_configured:
            "Бот ще не підключений. Підключення робить адміністратор системи під час розгортання.",
          bot: "Бот %{bot}",
          sent_today: "сьогодні надіслано: %{count}",
          linked: "Ваш Telegram прив'язано: пишіть боту /menu.",
          link: "Прив'язати мій Telegram",
          link_hint:
            "Відкриється бот, натисніть «Start». Після цього бот знає, що ви з CRM.",
          chats: "Чати для сповіщень",
          no_chats:
            "Люди й групи з'являються тут, коли пишуть боту /start. Увімкніть тих, кому слати сповіщення.",
          private: "Особистий чат",
          waiting: "чекає дозволу",
          invite: "Посилання для підключення",
          link_error: "Не вдалося створити посилання: %{error}",
          invite_person: "Людині:",
          invite_group: "Групі (додає бота в групу):",
          invite_copied:
            "Посилання скопійовано, надішліть його людям або в групу",
          invite_hint:
            "Людина відкриває посилання й тисне «Start»: сповіщення одразу йдуть їй. Діє 7 днів, нове посилання скасовує попереднє. Для групи — друге посилання: воно додає бота в групу й вмикає її.",
          events: "Що надсилати",
          events_hint:
            "Те саме можна перемикати з бота командою /menu. Тестові ліди й імпорт CSV сповіщень не шлють.",
          event: {
            new_lead: "🆕 Новий лід",
            overdue_task: "⏰ Прострочена задача",
            no_action_24h: "⚠️ Лід без дії понад 24 год",
            no_leads: "📉 Немає заявок N год (поріг у Meta Lead Ads)",
          },
        },
        meta: {
          hint: "Заявки з лід-форм Facebook та Instagram щохвилини",
          no_status: "Стан недоступний. Перевірте права або спробуйте пізніше.",
          not_configured:
            "Ще не підключено. Підключення робить адміністратор системи під час розгортання.",
          checked: "Остання перевірка: %{time}",
          never_checked: "Ще не перевіряли",
          counts: "Сьогодні: %{today} · за тиждень: %{week}",
          last_lead: "остання заявка %{time}",
          error: "Meta відповіла помилкою: %{error}",
          forms: "Лід-форми",
          forms_hint:
            "Усі форми сторінки підхоплюються самі. Вимкніть зайві, дайте зрозумілу назву: її видно на картці ліда.",
          no_forms: "Форми з'являться після першої перевірки.",
          archived: "Архівні в Meta: %{smart_count} (заявок не приймають)",
          take_leads: "Приймати заявки з цієї форми",
          form_week:
            "%{smart_count} за тиждень |||| %{smart_count} за тиждень |||| %{smart_count} за тиждень",
          routing: "Кому віддавати нові заявки",
          routing_round_robin: "По черзі",
          routing_none: "Без відповідального",
          participants_hint:
            "Хто в черзі. Нікого не вибрано: усі менеджери (роль «лише свої ліди»). Один у черзі отримує все.",
          routing_none_hint:
            "Нові заявки чекають, поки власник або РОП призначить відповідального.",
          alert: "Контроль надходження",
          alert_hours: "год без заявок: попередити (0 = вимкнено)",
          alert_hint:
            "Попередження надсилатиме Telegram, коли його підключимо.",
        },
      },
      roles: {
        title: "Ролі й доступ",
        description:
          "Що дозволено кожній ролі. Права власника змінити не можна.",
        new: "Нова роль",
        name: "Назва ролі",
        action: "Дія",
        delete: "Видалити роль",
        in_use: "Роль, яку має хтось із команди, видалити не можна",
        permissions: {
          "leads.all": "Бачити всі ліди",
          "leads.own": "Бачити лише свої ліди",
          "leads.transfer": "Передавати ліди між менеджерами",
          "apartments.edit": "Редагувати ціни й статуси квартир",
          dashboard: "Дашборд і аналітика",
          import: "Імпорт лідів",
          settings: "Налаштування й етапи воронки",
          team: "Команда й запрошення",
        },
      },
      reset_defaults: "Скинути до стандартних",
      save_error: "Не вдалося зберегти налаштування",
      saved: "Налаштування збережено",
      saving: "Зберігаємо...",
      tasks: {
        types: "Типи",
      },
      preferences: "Налаштування",
      title: "Налаштування",
      app_title: "Назва системи",
      sections: {
        branding: "Брендинг",
      },
      validation: {
        duplicate: "Дублікати (%{display_name}): %{items}",
        in_use:
          "Не можна видалити %{display_name}, які ще використовуються в угодах: %{items}",
        validating: "Перевіряємо…",
        entities: {
          categories: "категорії",
          stages: "етапи",
        },
      },
    },
    theme: {
      dark: "Темна",
      label: "Тема",
      light: "Світла",
      system: "Системна",
    },
    language: "Мова",
    funnel: {
      title: "Воронка",
      active: "Активні",
      lost: "Втрачені",
      all_managers: "Усі менеджери",
      all_sources: "Усі джерела",
      all_stages: "Усі етапи",
      new_lead: "Новий лід",
      in_stage: "в етапі %{count} дн.",
      in_stage_today: "в етапі менше дня",
      rooms: "%{count}-кімн.",
      apartment: "Кв. %{number}",
      empty_stage: "Порожньо",
      mobile_hint: "Оберіть етап угорі, щоб побачити його лідів.",
      units: {
        minutes: "хв",
        hours: "год",
        days: "дн.",
      },
      status: {
        no_call: "Без дзвінка %{count} %{unit}",
        overdue: "Прострочено %{count} %{unit}",
        today: "%{task} сьогодні о %{time}",
        tomorrow: "%{task} завтра о %{time}",
        later: "%{task} %{date}",
        booked_until: "Бронь до %{date}",
      },
      lost_list: {
        client: "Клієнт",
        reason: "Причина",
        lost_at_stage: "Втрачено на етапі",
        manager: "Менеджер",
        when: "Коли",
        restore: "Повернути в роботу",
        restored: "Лід повернуто на етап «Новий»",
        all: "Усі",
        hint: "Втрачений лід можна повернути в роботу, він потрапить на етап «Новий».",
        top_reason: "Найчастіша причина: «%{reason}», %{count} з %{total}.",
        empty: "Втрачених лідів немає",
      },
      lost_dialog: {
        title: "Чому лід втрачено?",
        description: "Причина обов'язкова: за нею рахується аналітика.",
        comment: "Коментар (для «Інше» обов'язковий)",
        comment_placeholder: "Коротко, що сталося",
        submit: "Втратити лід",
        done: "Лід перенесено у втрачені",
      },
      lead: {
        comments: "Коментарі",
        no_comments: "Коментарів ще немає.",
        form_answers: "Відповіді з форми",
        system: "Система",
        note_placeholder: "Що важливо знати про цього клієнта",
        add_comment: "Додати коментар",
        back: "Воронка",
        call: "Зателефонувати",
        new_task: "Нова задача",
        transfer: "Передати",
        lose: "Лід втрачено",
        call_result: "Результат дзвінка",
        comment: "Коментар",
        comment_placeholder: "Що домовились, що цікавить клієнта",
        next_action: "Наступна дія",
        next_action_placeholder: "Наприклад, показ квартири",
        when: "Коли",
        saved: "Дзвінок збережено",
        choose_result: "Оберіть результат дзвінка",
        history: "Історія",
        no_history: "Подій ще немає",
        contact: "Контакт",
        phone: "Телефон",
        source: "Джерело",
        form: "форма «%{form}»",
        created: "Створено",
        manager: "Відповідальний",
        apartment: "Квартира",
        change: "Змінити",
        no_apartment: "Квартиру не вибрано",
        no_apartment_choice: "Без квартири",
        section_number: "Секція %{section} · кв. %{number}",
        apartment_line: "%{floor} поверх · %{rooms}-кімнатна",
        tasks: "Задачі",
        no_tasks: "Відкритих задач немає",
        task_text: "Що зробити",
        add_task: "Додати задачу",
        task_added: "Задачу додано",
        transferred: "Лід передано",
        stage_changed: "Етап змінено",
        not_found: "Лід не знайдено",
        no_call_badge: "Без дзвінка",
      },
      new: {
        title: "Новий лід",
        phone: "Телефон",
        name: "Ім'я",
        name_placeholder: "Як звати",
        source: "Звідки",
        rooms: "Що цікавить",
        rooms_option: "%{count}-кімн.",
        comment: "Коментар",
        comment_placeholder: "Що сказав клієнт",
        manager: "Відповідальний",
        submit: "Створити лід",
        attention: "Увага",
        duplicate: "Такий номер уже є: %{name}, етап «%{stage}».",
        open: "Відкрити",
        created: "Лід створено",
        no_name: "Без імені",
      },
      events: {
        lead_created: "Лід створено",
        lead_created_from: "Лід створено, джерело: %{source}",
        lead_assigned: "Лід передано іншому менеджеру",
        deal_created: "Угоду створено",
        deal_stage_changed: "Етап: %{from} → %{to}",
        deal_lost: "Лід втрачено: %{reason}",
        deal_assigned: "Угоду передано іншому менеджеру",
        deal_apartment_changed: "Змінено квартиру",
        call_logged: "Дзвінок: %{result}",
        task_created: "Задача: %{task}",
        task_done: "Задачу виконано",
        other: "Подія",
      },
    },
    today: {
      title: "Сьогодні",
      all: "Усе",
      new: "Нові",
      overdue: "Прострочено",
      call_now: "Дзвонити зараз",
      tasks_today: "Задачі на сьогодні",
      nothing: "На сьогодні все зроблено",
      call: "Подзвонити: %{name}",
      yesterday: "Вчора",
      overdue_badge: "Прострочено",
      new_badge: "Новий",
    },
    buyer: {
      title: "Профіль покупця",
      temperature_label: "Температура",
      rooms_label: "Кімнати",
      consent_given: "Є згода",
      budget: "Бюджет",
      family: "Сім'я",
      decision_maker: "Хто вирішує",
      consent: "Згода на розсилку",
      consent_since: "згода з %{date}",
      consent_hint: "Без згоди клієнт не потрапить у розсилку",
      placeholder: {
        budget_min: "від",
        budget_max: "до",
        family: "напр. пара, двоє дітей",
        decision_maker: "напр. дружина, батьки",
        contact_time: "зручний час",
        residence_country: "країна",
      },
      temperature: { cold: "❄ Холодний", warm: "🌤 Теплий", hot: "🔥 Гарячий" },
      payment_method: {
        label: "Оплата",
        cash: "Готівка",
        installments: "Розтермінування",
        mortgage: "Іпотека",
        eoselia: "єОселя",
        certificate: "Сертифікат",
        other: "Інше",
      },
      purpose: {
        label: "Мета",
        live: "Жити",
        invest: "Інвестиція",
        family: "Для рідних",
        rent: "Здавати",
      },
      buy_timing: {
        label: "Коли купує",
        now: "Зараз",
        months: "1–3 міс.",
        half_year: "Пів року",
        thinking: "Думає",
      },
      wishes: {
        label: "Що важливо",
        floor_low: "Низький поверх",
        floor_high: "Високий поверх",
        balcony: "Балкон",
        view: "Вид",
        parking: "Паркінг",
        storage: "Комора",
      },
      residence: {
        label: "Де живе",
        local: "Тячів",
        region: "Закарпаття",
        ukraine: "Інша область",
        abroad: "За кордоном",
      },
      language: {
        label: "Мова",
        uk: "Українська",
        hu: "Угорська",
        ro: "Румунська",
        other: "Інша",
      },
      contact_channel: {
        label: "Зв'язок",
        call: "Дзвінок",
        viber: "Viber",
        telegram: "Telegram",
        whatsapp: "WhatsApp",
      },
      objections: {
        label: "Заперечення",
        expensive: "Дорого",
        far: "Далеко",
        waiting_build: "Чекає здачі",
        distrust: "Не довіряє",
        comparing: "Порівнює з іншим ЖК",
        other: "Інше",
      },
    },
    scripts: {
      title: "Скрипти",
      on_call: "Скрипт розмови",
      if_client_says: "Якщо клієнт каже",
      all: "Усі скрипти",
      any_stage: "Будь-який етап",
      new: "Новий скрипт",
      new_title: "Новий скрипт",
      step_title: "Привітання",
      name: "Назва",
      stage: "Для етапу",
      active: "Увімкнено",
      steps: "Кроки розмови",
      name_hint: "Пишіть {ім'я} — у картці ліда підставиться ім'я клієнта.",
      add_step: "Додати крок",
      objections: "Відповіді на заперечення",
      custom_objection: "Своє заперечення",
      steps_count:
        "%{smart_count} крок |||| %{smart_count} кроки |||| %{smart_count} кроків",
      empty: "Скриптів ще немає.",
      saved: "Скрипт збережено",
      confirm_delete: "Видалити цей скрипт?",
      ai_title: "AI-аналіз дзвінків",
      ai_hint:
        "Коли підключимо телефонію з записами, кожен дзвінок розшифровуватиметься й звірятиметься з цим скриптом: оцінка, де менеджер відійшов від скрипту, які заперечення прозвучали, наступний крок.",
    },
    tasks_page: {
      title: "Задачі",
      tab_today: "Сьогодні",
      tab_overdue: "Прострочені",
      tab_all: "Усі",
      overdue: "Прострочені",
      today: "Сьогодні",
      later: "Пізніше",
      no_date: "Без терміну",
      empty: "Усе, що на вас чекало, закрито.",
      done: "Задачу виконано",
      empty_title: "Усе зроблено!",
      action_done: "Виконано",
      minutes: "хв",
      hour: "год",
      tomorrow: "Завтра",
      open: "Відкрити",
      focus: "Зараз у фокусі",
      in: "через %{time}",
      late: "прострочено %{time}",
      min_short: "%{count} хв",
      hour_short: "%{count} год",
      progress: "Сьогодні виконано %{done} з %{total}",
      left_today:
        "Залишилась %{smart_count} задача |||| Залишилось %{smart_count} задачі |||| Залишилось %{smart_count} задач",
      all_done: "На сьогодні все. Красиво 👏",
      free_day: "На сьогодні задач немає",
      sound_on: "Звук",
      sound_off: "Без звуку",
      nudge: {
        soon: "⏰ Через кілька хвилин",
        now: "🔔 Час",
        overdue: "⚠️ Прострочено",
      },
    },
    import_leads: {
      title: "Імпорт лідів",
      subtitle: "Завантажте файл CSV, наприклад вивантаження з Meta Lead Ads.",
      step_file: "Файл",
      step_columns: "Колонки",
      step_check: "Перевірка",
      choose: "Оберіть файл CSV",
      formats:
        "CSV або TSV, кома, крапка з комою чи табуляція. Вивантаження Meta відкривається як є.",
      unreadable:
        "Не вдалося прочитати файл. Перевірте, що це CSV з рядком заголовків.",
      mapping_title: "Що з якою колонкою зіставити",
      file: "Файл",
      rows: "%{smart_count} рядок |||| %{smart_count} рядки |||| %{smart_count} рядків",
      default_source: "Джерело, якщо у файлі немає",
      manager: "Відповідальний",
      no_manager: "Без відповідального (роздати пізніше)",
      hint: "Перед імпортом система перевірить дублікати за телефоном і рядки без номера. Усі імпортовані ліди потраплять на етап «Новий».",
      need_phone: "Зіставте колонку з телефоном: без неї ліда не створити.",
      next: "Далі",
      will_import: "буде імпортовано",
      no_phone: "без телефону",
      dup_base: "вже є в базі",
      dup_file: "повтори у файлі",
      and_more: "і ще %{count}",
      run: "Імпортувати %{smart_count} лід |||| Імпортувати %{smart_count} ліди |||| Імпортувати %{smart_count} лідів",
      progress: "Імпортовано %{done} з %{total}",
      failed: "помилок: %{count}",
      to_funnel: "До воронки",
      targets: {
        full_name: "Ім'я та прізвище",
        first_name: "Ім'я",
        last_name: "Прізвище",
        phone: "Телефон",
        email: "Пошта",
        created_at: "Дата створення",
        campaign: "Кампанія",
        form: "Форма",
        source: "Джерело",
        rooms: "Кімнат",
        utm_source: "utm_source",
        utm_medium: "utm_medium",
        utm_campaign: "utm_campaign",
        utm_content: "utm_content",
        utm_term: "utm_term",
        comment: "У коментар",
        ignore: "Не імпортувати",
      },
    },
    apartments: {
      empty:
        "Квартир ще немає. Завантажте реєстр квартир (секції, поверхи, площі).",
      section: "Секція %{section}",
      all: "Усі",
      area: "Площа",
      area_filters: {
        any: "Будь-яка",
        under40: "до 40 м²",
        "40to60": "40–60 м²",
        over60: "від 60 м²",
      },
      counts: {
        free: "Вільні",
        booked: "Бронь",
        sold: "Продані",
        off: "Не в продажу",
      },
      rooms_short: "%{count}к",
      only_free: "Лише вільні",
      section_short: "Секція %{section}",
      pick_title: "Оберіть квартиру",
      pick_hint:
        "Зелені вільні, на них можна натиснути. Спершу показано кімнатність, яку хотів клієнт.",
      free_of: "вільні %{free} з %{total}",
      stripe_hint: "Смужка зліва показує кімнатність",
      floor: "поверх",
      until: "до %{date}",
      pick: "Оберіть квартиру на шахматці.",
      total: "Загальна",
      living: "Житлова",
      held_for: "Угода:",
      price: "Ціна за м², $",
      no_price: "Ще не вказано",
      total_price: "Разом: %{total} $",
      saved: "Квартиру збережено",
      rights_hint:
        "Ціни й статуси змінює той, хто має право «Редагувати ціни й статуси квартир». Решта бачить шахматку без редагування.",
    },
    owner_dashboard: {
      periods: {
        week: "Тиждень",
        month: "Місяць",
        all: "Весь час",
      },
      reaction: "Час першої реакції",
      reaction_hint: "медіана: від появи ліда до першої дії",
      call_5: "Дзвінок за 5 хв",
      call_15: "за 15 хв: %{value}",
      no_action: "Без дії понад 24 год",
      no_action_hint: "лідів без дзвінка й задачі",
      overdue: "Прострочені задачі",
      overdue_hint: "відкриті задачі з терміном у минулому",
      funnel: "Де гине воронка",
      funnel_hint:
        "Відсоток показує, скільки лідів дійшло від попереднього етапу.",
      warm: "Найтепліші ліди",
      no_warm: "Теплих лідів поки немає",
      warm_hint: "Рахується за простими правилами, їх видно в кожному рядку.",
      rules: {
        answered: "відповів на дзвінок",
        viewed: "був на показі",
        repeat: "повторний контакт",
      },
      sources: "Джерела → показ → продаж",
      source: "Джерело",
      source_leads: "Ліди",
      source_viewings: "Дійшли до показу",
      source_won: "Продано",
      more: "Ще",
    },
    navigation: {
      label: "Навігація CRM",
      pipeline: "Воронка",
      tasks: "Задачі",
      today: "Сьогодні",
      import_leads: "Імпорт лідів",
      apartments: "Квартири",
      team: "Команда",
    },
    profile: {
      add_secondary_email: "Додати email",
      email_taken: "%{email} вже використовує інший користувач",
      no_secondary_emails: "Немає",
      secondary_email_invalid: "%{email} не є коректною адресою",
      secondary_email_is_primary: "%{email} вже є вашою основною адресою",
      secondary_email_taken: "%{email} вже використовує інший користувач",
      too_many_secondary_emails: "Не можна додати більше 10 додаткових адрес",
      secondary_emails_help:
        "Інші адреси, з яких ви надсилаєте листи. Залиште поле порожнім, щоб видалити адресу.",
      inbound: {
        description:
          "Надсилайте листи на вхідну адресу сервера, наприклад додавши її в поле %{field}. CRM обробить листи й додасть нотатки до відповідних контактів.",
        title: "Вхідна пошта",
      },
      mcp: {
        title: "MCP-сервер",
        description:
          "За цим посиланням можна підключити AI-асистента до даних CRM через Model Context Protocol (MCP).",
      },
      password: {
        change: "Змінити пароль",
      },
      password_reset_sent: "Лист для скидання пароля надіслано на вашу пошту",
      record_not_found: "Запис не знайдено",
      title: "Профіль",
      updated: "Профіль оновлено",
      update_error: "Сталася помилка. Спробуйте ще раз",
    },
    validation: {
      invalid_url: "Має бути коректне посилання",
      invalid_linkedin_url: "Посилання має бути з linkedin.com",
    },
  },
} satisfies CrmMessages;
